import React from "react";
import Avatar from "Components/common/Avatar/Avatar";
import Actions from "Components/project/Workstreams/List/Row/Actions/Actions";
import Axios from "Source/axiosPool";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import LongText from "Source/components/common/Elements/LongText/LongText";
import { copyToClipboard } from "Source/util/navigator";
import { FALLBACK_EMAIL } from "Source/components/project/Config/Config";
import { connect } from "react-redux";

@connect(store => {
    return {
        list: store.workstream,
    };
})

class Row extends React.Component {
    constructor(props) {
        super(props);

        _.map(["setActive"], fn => {
            this[fn] = this[fn].bind(this);
        });
        
        this.state = {
            isActive: false
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    setActive(value) {
        this.setState({
            ...this.state,
            isActive: value
        })
    }

    handleCopy = () => {
        const { workstream } = this.props;

        copyToClipboard(workstream.email);
    }
    
    render() {
        const { workstream, list, dispatch } = this.props;
        const handleInactive = () => {
            const url = `/api/workstream/status/${workstream.id}`;
            const params = { isActive: workstream.isActive?0:1 };

            dispatch({type: "SET_SCREEN_LOADER", Loading: true});
            Axios.put(url, params)
            .then(response=> {
                if(response) {
                    const workstreamList = list.List.map(w=>{
                        return {
                            ...w,
                            ...(w.id === response.data.id?{isActive: response.data.isActive}:{})
                        }
                    })
                    dispatch({type: "SET_WORKSTREAM_LIST", list: workstreamList});
                    dispatch({type: "SET_SCREEN_LOADER", Loading: false});
                }
            });
        }

        const workstreamEmail = workstream.email || FALLBACK_EMAIL;

        return (
            <tr>
                <td>{ workstream.workstream }</td>
                <td>{ workstream.isActive ? "Active" : "Inactive" }</td>
                <td>{`${ workstream.lead.firstName} ${workstream.lead.lastName}`}</td>
                <td>
                    <div class="workstreamEmailContainer">
                        <LongText
                            value={workstreamEmail}
                            tooltipId={`${workstream.id}_workstreamEmail`}
                            maxLength={25}
                        />
                        {workstreamEmail !== FALLBACK_EMAIL &&
                             <a onClick={this.handleCopy}><i class="material-icons">content_copy</i></a>
                        }
                    </div>
                </td>
                <td>
                    <div class="avatarRowContainer">
                        {workstream.workstreamMembers && workstream.workstreamMembers.filter(m => m).slice(0, 5).map((m, i) => 
                            <Avatar 
                                key={`membersColumn_${workstream.id}_${m.user.id}_${i}`} 
                                id={`${workstream.id}_${m.user.id}`} 
                                name={`${m.user.firstName} ${m.user.lastName}`} 
                                image={m.user.avatar !== "default.png" ? `/api/file/profile_pictures/${m.user.avatar}` : null} 
                            />)}
                        {workstream.workstreamMembers && workstream.workstreamMembers.filter(m => m).length > 5 && (
                            <div class="avatarElement avatarMore">
                                <div class="avatarContainer"   data-tooltip-id={`memberCount_${workstream.id}_tooltip`}>
                                    <div class="avatarItem">+{workstream.workstreamMembers.length - 5}</div>
                                </div>
                                <Tooltip id={`memberCount_${workstream.id}_tooltip`}  place="bottom" effect="solid">
                                    {workstream.workstreamMembers && workstream.workstreamMembers.filter(m => m).slice(5, workstream.workstreamMembers.length).map((m, i) => 
                                        <p key={`otherWorkstreamMembers_${workstream.id}_${m.user.id}_${i}`}>{`${m.user.firstName} ${m.user.lastName}`}</p>)
                                    }
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </td>
                <td class="actionMainContainer">
                    <Actions 
                    workstream={workstream}
                    onActions={this.setActive} 
                    isActive={false} 
                    inModal={true} 
                    handleInactive={handleInactive} 
                    triggerEdit={this.props.triggerEdit}            
                    hasChanges={this.props.hasChanges} 
                    isEdit={this.props.isEdit}/>
                </td>
            </tr>
        );
    }
}

export default Row;